import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';

import { HeapService } from '#core/services/heap.service';
import { SessionStore } from '#core/store/session.store';

interface RouterListenerOptions {
    event2Class: new (...args: any[]) => any;
    matchUrl: string;
    callback: () => void;
}

/**
 * This service is used to listen to router events and execute a side effect when a specific event is triggered
 */
@Injectable()
export class RouterListenerService {
    private readonly _router = inject(Router);

    private readonly _sessionStore = inject(SessionStore);
    private readonly _heapService = inject(HeapService);
    private readonly _destroyRef = inject(DestroyRef);

    optionsArray: RouterListenerOptions[] = [
        {
            event2Class: NavigationEnd,
            matchUrl: '/groups',
            callback: this._sendHeapProperties,
        },
    ];

    initialized = false;

    init(): void {
        if (this.initialized) {
            return;
        }
        this.initialized = true;

        this._router.events.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((event) => {
            this.optionsArray.forEach((options) => {
                if (event instanceof options.event2Class && this._router.url.includes(options.matchUrl)) {
                    options.callback.call(this);
                }
            });
        });
    }

    private _sendHeapProperties(): void {
        const currentUser = this._sessionStore.currentUser();
        const currentUserRestaurants = this._sessionStore.currentUserRestaurants();
        this._heapService.addEventProperties({
            userId: currentUser.id,
            userName: currentUser.name,
            userRestaurantsCount: currentUserRestaurants.length,
            role: currentUser.role,
            userEmail: currentUser.email,
            mobileAppSession: false,
            allBusinesses: true,
        });
    }
}
